import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EMPTY, Observable} from 'rxjs';
import {CreditLimitDailyModel} from './credit-limit-daily.model';
import {environment} from '../../core/environments/environment';
import {catchError, map} from 'rxjs/operators';


@Injectable({
	providedIn: 'root'
})
export class CreditService {

	constructor(private http: HttpClient) {

	}

	updateBlockInfo(rowData: any){ 

		console.log("updateBlockInfo: " + rowData)

		return this.http.put(
			environment.financialUrl + '/limcred/block/' + rowData.id 
			+ '?blockUser=' + rowData.blockUser 
			+'&dealerId=' + rowData.dealerNo 
			+'&account=' + rowData.account
			+'&dateCredit='+  rowData.datalimitCredit
			, null);
	}

	getLimitCredit(
		date: String,
		dealer: bigint,
		searchByCreditDate: boolean): Observable<CreditLimitDailyModel[]> {

		let request = '';

		console.log("dateCredit=" + date)

		if(searchByCreditDate){

			if (date != undefined && date !== null) {
				request += (request.length > 0) ? '&' : '';
				request += 'dateCredit=' + date;
			}

		} else {

			if (date !== undefined && date !== null) {
				request += (request.length > 0) ? '&' : '';
				request += 'data=' + date;
			}

		}


		if (dealer !== undefined && dealer !== null) {
			request += (request.length > 0) ? '&' : '';
			request += 'dealerNo=' + dealer;
		}

		console.log("REQUEST URL: " + request);
		

		if(searchByCreditDate){
			return this.http.get<any>(environment.financialUrl + '/limcred/getCreditLimit?' + request);
		} else {
			return this.http.get(environment.financialUrl + '/limcred/balance/getALLBalances?' + request)
			.pipe(

				map(

					result => {

						if (result['error']) {

							if (result['error']['errorCode'] === '204 NO_CONTENT') {
								return result['result'];

							} else {
								return result['result'];
							}
							
						} else {
							return result['resultList'];
						}

					}
				),	catchError(e => {
						return EMPTY as Observable<CreditLimitDailyModel>;
					}	
				)
			)
			.pipe(
				catchError(error => {
					console.log('Caught in CatchError - WalletService.getWalletDailyPosition');
					throw new Error(error);
				})
			);	
		}
	}
}
